import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { BranchTeamModel } from "../../../model/branch/BranchTeamModel";
import ShowToast from "../../../widget/common/ui/Toast";

const BranchTeamProvider = new (class BranchTeamProvider {
  getTeamListAPI = async (): Promise<BranchTeamModel | null> => {
    ApiUrls.init();

    const barnchId: string = CacheStorage.getValue(StorageKeys.branch_id);
    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}search/get_team_profile_list`;
    const body: any = {
      account_id: accountId,
      branch_id: barnchId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const branchTeamListModel: BranchTeamModel = response;
        return branchTeamListModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default BranchTeamProvider;
